import React, { useEffect, useState } from 'react'
import { useStores } from '@trivie/core'
import { Button, color } from '@trivie/ui-mobile'
import { Text } from '@trivie/ui-web/components/text'
import { ResourceIcon } from '@trivie/ui-web/components/resource-icon'
import { ActivityIndicator, TouchableOpacity, View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { AuthenticationApi, QuizApi } from '@trivie/core/src/services/api-objects'
import { useHistory, useRouteMatch } from 'react-router-dom'
import trivieDefault from '../play/play-screen/default-backdrop.png'
import { GetBackgroundColorOfMimeType } from '@trivie/core'

export const ShareQuizScreen: React.FunctionComponent<any> = observer((props: any) => {
  const { userStore, quizStore } = useStores()
  const { sharedQuiz, setSharedQuiz } = userStore

  const { limitStatus, getLimitStatus } = quizStore

  const [isLogin, setIsLogin] = useState(false)

  const match = useRouteMatch<any>('/share/:code')
  const code = String(match?.params?.code)

  useEffect(() => {
    if (userStore.token) {
      getLimitStatus()
    }

    QuizApi.getSharedQuiz(code).then((resp) => {
      setSharedQuiz({ ...resp.data, code })
    })
  }, [])

  const startQuiz = () => {
    history.push(
      `/game/quiz/?assignment_id=${userStore.sharedQuiz?.metadata?.assignment_id}&topic_id=${userStore.sharedQuiz?.metadata?.topic_id}&quiz_id=${userStore.sharedQuiz?.quiz_id}&path_id=${userStore.sharedQuiz?.metadata?.path_id}&content_user_id=${userStore.sharedQuiz?.metadata?.content_user_id}`,
    )
  }

  const history = useHistory()
  const login = () => {
    history.push('/login/magic')
  }

  const signup = () => history.push('/signup')

  const getExtension = (resource) => {
    if (resource?.extension) {
      return resource.extension
    } else if (resource?.url) {
      return 'url'
    }
    return null
  }

  const handleOnClick = (item: any) => {
    if (userStore.token) {
      const target = item?.download_url || item?.url
      window.open(target, '_blank', 'noopener')
    }
  }

  return (
    <div
      style={{
        background: color.quizBackground,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      {!userStore.sharedQuiz ? (
        <View style={{ flexDirection: 'column', flex: 1, justifyContent: 'center' }}>
          <ActivityIndicator />
        </View>
      ) : (
        <div style={ROOT}>
          <div style={CONTAINER}>
            <div style={CONTENT}>
              <div style={HEADER}>
                <div
                  style={{
                    position: 'relative',
                    height: 225,
                    borderRadius: 16,
                    overflow: 'hidden',
                    marginBottom: 32,
                    width: '100%',
                  }}
                >
                  <img
                    src={
                      userStore?.sharedQuiz?.photo_url
                        ? userStore?.sharedQuiz?.photo_url
                        : trivieDefault
                    }
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <Text
                  variant="headline"
                  text={userStore.sharedQuiz?.quiz_title}
                  style={{ textAlign: 'center', marginBottom: 4, color: color.white }}
                />
                <Text
                  variant="body1Medium"
                  tx="Quiz.numQuestions"
                  txOptions={{ count: sharedQuiz?.question_count }}
                  style={{
                    textAlign: 'center',
                    color: 'rgba(255, 255, 255, 0.70)',
                    marginBottom: 32,
                  }}
                />
                <Text
                  variant="body1Medium"
                  text={userStore?.sharedQuiz?.description}
                  style={{
                    textAlign: 'center',
                    color: color.white,
                    marginBottom: 32,
                  }}
                />
              </div>
              <div style={{ width: '100vw', maxWidth: 600, paddingLeft: 20, paddingRight: 20 }}>
                {userStore.sharedQuiz?.sources.length > 0 && (
                  <div style={{ marginBottom: 20 }}>
                    <Text
                      tx="Onboarding.source"
                      variant="labelEmphasized"
                      style={{ color: color.white }}
                    />
                  </div>
                )}
                {userStore.sharedQuiz?.sources.map((source) => {
                  return (
                    <TouchableOpacity onPress={() => handleOnClick(source)}>
                      <View style={SOURCE_CONTAINER}>
                        <View style={{ alignItems: 'center', flexDirection: 'row', flex: 1 }}>
                          <View
                            style={{
                              alignItems: 'center',
                              flexDirection: 'row',
                              backgroundColor: GetBackgroundColorOfMimeType(getExtension(source)),
                              padding: 6,
                              borderRadius: 10,
                            }}
                          >
                            <ResourceIcon extension={getExtension(source)} white={true} />
                          </View>
                          <View style={SOURCE_INFO}>
                            <Text
                              variant="labelMedium"
                              text={source?.title}
                              style={{
                                color: color.white,
                                overflowWrap: 'break-word',
                                userSelect: 'none',
                                display: '-webkit-box',
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            />
                            <Text
                              text={
                                source?.url
                                  ? new URL(source.url).hostname
                                  : source?.extension?.toUpperCase()
                              }
                              variant="body1Medium"
                              style={{ color: '#FFFFFF80' }}
                            />
                          </View>
                        </View>
                      </View>
                    </TouchableOpacity>
                  )
                })}
              </div>
              <div style={{ width: '100vw', maxWidth: 600, paddingLeft: 20, paddingRight: 20 }}>
                {!userStore.token && !userStore?.sharedQuiz?.user_id ? (
                  <div style={{ marginBottom: 24, textAlign: 'center' }}>
                    <Text
                      variant="body1Medium"
                      text="You need an account to take this quiz"
                      style={{ color: color.white }}
                    />
                  </div>
                ) : null}
                {userStore.token && limitStatus?.respondent_limit_reached ? (
                  <>
                    <div style={{ marginBottom: 24, textAlign: 'center' }}>
                      <Text
                        text={`This Trivie workspace has reached its quiz limit for the month.`}
                        variant="titleEmphasized"
                        style={{ color: color.white }}
                      />
                    </div>
                    <Button
                      onPress={() => {
                        const adminEmailAddress = limitStatus?.owner_email
                        const subjectText = 'Requesting access for Trivie'
                        const bodyText = `${limitStatus?.owner_display_name}, %0d%0a%0d%0aI tried to take ${userStore.sharedQuiz?.quiz_title} but wasn't able to because we've reached our quiz limit for the month. %0d%0a%0d%0aPlease log in and upgrade our plan so I can start learning!`
                        window.open(
                          `mailto:${adminEmailAddress}?subject=${subjectText}&body=${bodyText}`,
                        )
                      }}
                      tx={'Game.requestAccess'}
                    />
                  </>
                ) : userStore.token || userStore.sharedQuiz?.user_id ? (
                  <Button
                    onPress={() => {
                      if (!userStore.token) {
                        // login
                        AuthenticationApi.loginShared(
                          userStore.sharedQuiz.code,
                          userStore.sharedQuiz.workspace_id,
                          userStore.sharedQuiz?.quiz_id,
                        ).then((resp) => {
                          if (resp.data.metadata) {
                            userStore.setSharedQuiz({ ...sharedQuiz, metadata: resp.data.metadata })
                          }
                          userStore.setToken(resp.data.token)
                          userStore.getUser(resp.data.user_id).then(() => {
                            if (!userStore?.user?.first_name || !userStore.user?.last_name) {
                              history.push('/login/magic/sent')
                            } else {
                              startQuiz()
                            }
                          })
                        })
                      } else if (userStore?.user?.email) {
                        AuthenticationApi.loginShared(
                          userStore.sharedQuiz.code,
                          userStore.sharedQuiz.workspace_id,
                          userStore.sharedQuiz?.quiz_id,
                          userStore?.user?.email,
                        ).then((resp) => {
                          if (resp.data.metadata) {
                            userStore.setSharedQuiz({ ...sharedQuiz, metadata: resp.data.metadata })
                            startQuiz()
                          }
                        })
                      }
                    }}
                    text="Start Quiz"
                  />
                ) : null}
                {!userStore.token && !userStore.sharedQuiz?.user_id && (
                  <>
                    <Button
                      style={{
                        backgroundColor: color.quizBackground,
                        borderColor: color.blue,
                        borderWidth: 1,
                        marginBottom: 16,
                      }}
                      onPress={() => {
                        setIsLogin(true)
                        login()
                      }}
                      tx="Onboarding.Login.logIn"
                    />
                    <Button
                      onPress={() => {
                        setIsLogin(false)
                        signup()
                      }}
                      tx="Onboarding.newSignup"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
})

const FULL: ViewStyle = { flex: 1, padding: 20 }

const SOURCE_CONTAINER: ViewStyle = {
  // @ts-ignore
  cursor: 'pointer',
  display: 'flex',
  borderWidth: 1,
  borderColor: `rgba(255, 255, 255, 0.5)`,
  flexDirection: 'row',
  backgroundColor: color.quizBackground,
  alignItems: 'center',
  borderRadius: 16,
  height: 65,
  paddingLeft: 16,
  paddingRight: 16,
  marginBottom: 12,
}
const SOURCE_INFO: ViewStyle = {
  flexDirection: 'column',
  flex: 1,
  alignSelf: 'center',
  justifyContent: 'center',
  marginLeft: 16,
}

const ROOT: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  padding: 24,
}
const CONTAINER: React.CSSProperties = {
  flexDirection: 'column',
  flex: 1,
  display: 'flex',
  justifyContent: 'space-evenly',
  alignSelf: 'center',
}
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignSelf: 'center',
}
const HEADER: React.CSSProperties = {
  flexDirection: 'column',
  display: 'flex',
  maxWidth: 600,
  width: '100%',
  paddingLeft: 20,
  paddingRight: 20,
}
